import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

require('highcharts/modules/exporting')(Highcharts);

interface IStackedBarChartComponentProps {
  title: string
  categories: string[]
  dataPoints: any[]
  noDataMessage?: string
  click?: any
  htmlSubtitle?: string
}

interface IStackedBarChartComponentState {
  trendChartRef: any
  trendGraphOptions: any
}

export class StackedBarChartComponent extends React.Component<IStackedBarChartComponentProps> {
  state: IStackedBarChartComponentState = {
    trendChartRef: undefined,
    trendGraphOptions: undefined
  }
  componentDidMount() {
    this.state.trendChartRef = React.createRef();
    if (this.props.dataPoints.length > 0) {
      this.setTrendGraphOptions();
    }
  }

  componentDidUpdate(prevProps: IStackedBarChartComponentProps, prevState: IStackedBarChartComponentState) {

    if (prevProps.dataPoints !== this.props.dataPoints) {
      this.setTrendGraphOptions();
    }
  }

  setTrendGraphOptions() {
    const { categories, click, dataPoints, noDataMessage, title, htmlSubtitle } = this.props;

    let subtitle = {};
    if (htmlSubtitle) {
      subtitle = {
        useHTML: true,
        text: htmlSubtitle
      };
    }

    this.setState({
      trendGraphOptions: {
        lang: {
          noData: noDataMessage
        },
        chart: {
          type: 'bar',
          height: 240
        },
        title: {
          useHTML: true,
          text: title,
          x: 0,
          y: 5,
          align: 'left',
          style: { display: 'none' }
        },
        subtitle,
        xAxis: {
          categories,
          girdLineWidth: 0,
          tickWidth: 0,
          lineWidth: 0,
          labels: {
            enabled: false
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          },
          labels: {
            enabled: false
          },
          gridLineWidth: 0,
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: true,
          symbolRadius: 0,
          itemStyle: {
            font: '9pt Trebuchet MS, Verdana, sans-serif',
            color: 'black'
          },
          itemHoverStyle: {
            color: 'gray'
          }
        },
        tooltip: {
          valueSuffix: '%',
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            cursor: 'pointer',
            point: click ? click : () => {
              return;
            }
          },
          bar: {
            dataLabels: {
              enabled: true,
              style: {
                color: 'white',
                fontSize: '12px',
                textShadow: false,
              },
              formatter() {
                if (this.y > 5) {
                  return this.y + '%';
                } else {
                  return null;
                }
              },
              allowOverlap: true,
            }
          }
        },
        colors: ['#0493FC', '#E24585', '#132749', '#B30838', '#FFAA00', '#3BB273',
          '#007F80', '#CC66FF', '#6AF9C4'],
        colorIndex: 0,
        series: dataPoints,
        exporting: {
          chartOptions: {
            title: {
              style: {
                display: 'block'
              }
            },
            plotOptions: {
              series: {
                dataLabels: {
                  enabled: true
                }
              }
            }
          },
          buttons: {
            contextButton: {
              symbol: 'url(images/bars.png)',
            }
          }
        },

        navigation: {
          buttonOptions: {
            verticalAlign: 'top',
            y: -10
          }
        }
      }
    }, () => {
      this.state.trendChartRef.current.chart.reflow()
    });
  }

  render() {
    const { trendChartRef, trendGraphOptions } = this.state;
    return (
      <div>
        <section className="highcharts-component">
          {
            (trendGraphOptions && trendChartRef) &&
            <HighchartsReact
              highcharts={Highcharts}
              options={trendGraphOptions}
              allowChartUpdate={true}
              ref={trendChartRef}
              immutable={true}
            />
          }
        </section>
      </div>
    );
  }
}
